export default __webpack_public_path__ + "static/media/card-5.d5f77537.jpeg";